// extracted by mini-css-extract-plugin
export var inlineLink = "_3y-0";
export var inlineLinkButton = "_3y-1";